<template>
  <div class="d-flex">
    <button
      v-for="(layout, index) in layoutOptions"
      :key="'layout_btn' + index"
      id="LayoutBtnsTooltip"
      variant="light"
      size="sm"
      :class="layout.isActive ? 'grid-buton-active' : ''"
      class="btn-view-custom btn-light-new-grid black text-size-large p-2 border-0"
      @click="handleLayoutChangeClick(layout.text, $event)"
    >
      <img class="layout-change-icon" :src="layout.icon" alt="" />
    </button>
  </div>
</template>
<script>
export default {
  props: ["toggleLayout"],

  data() {
    return {
      layoutOptions: [
        {
          text: "LargeView",
          type: "large",
          isActive: true,
          icon:
            "https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/grid-2-solid.svg"
        },
        {
          text: "SmallView",
          type: "small",
          isActive: false,
          icon:
            "https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/grid-solid.svg"
        },
        {
          text: "ListView",
          type: "list",
          isActive: false,
          icon:
            "https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/list-solid.svg"
        }
      ]
    };
  },
  methods: {
    handleLayoutChangeClick(layoutType) {
      this.layoutOptions.forEach(element => {
        if (element.text == layoutType) {
          element.isActive = true;
        } else {
          element.isActive = false;
        }
      });
      this.toggleLayout(layoutType);
    }
  }
};
</script>
